export const Winvent = {
	"panels": [{
		"index": 0,
		"paperType": "A4",
		"height": 297,
		"width": 210,
		"paperHeader": 43.5,
		"paperFooter": 419.52755905511816,
		"printElements": [{
			"options": {
				"left": 289.5,
				"top": 6,
				"height": 30,
				"width": 105,
				"title": "的流向记录",
				"fontSize": 16,
				"fontWeight": "800",
				"textContentVerticalAlign": "middle",
				"backgroundColor": "#1E90FF",
				"color": "#FFFFFF",
				"field": ""
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 30,
				"top": 45,
				"height": 20,
				"width": 100,
				"title": "业务日期：",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 1.5,
				"top": 76.5,
				"height": 102,
				"width": 594,
				"field": "tableData",
				"tableBorder": "border",
				"headerHeight": 35,
				"rowHeight": 30,
				"columns": [
					[{
						"title": "行号",
						"field": "rowNum",
						"width": 19.277386182363383,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "rowNum"
					}, {
						"title": "系统序号",
						"field": "sysNum",
						"width": 44.39766908026964,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "sysNum"
					}, {
						"title": "药品名称",
						"field": "drugName",
						"width": 46.430069178146695,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "drugName"
					}, {
						"title": "入库库房",
						"field": "storage",
						"width": 46.352973268992315,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "storage"
					}, {
						"title": "业务来源",
						"field": "source",
						"width": 46.626806213466594,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "source"
					}, {
						"title": "变化数量",
						"field": "changeQty",
						"width": 40.23675201088578,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "changeQty"
					}, {
						"title": "变化前库",
						"field": "beforeQty",
						"width": 50.440045996180395,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "beforeQty"
					}, {
						"title": "变化后库",
						"field": "afterQty",
						"width": 50.08081430292099,
						"align": "center",
						"colspan": 1,
						"rowspan": 1,
						"checked": true,
						"columnId": "afterQty"
					}, {
						"title": "计量单位",
						"field": "unt",
						"width": 43.238040207040164,
						"colspan": 1,
						"rowspan": 1,
						"checked": true
					}, {
						"title": "成本单价",
						"field": "purcPric",
						"width": 46.61024127840598,
						"colspan": 1,
						"rowspan": 1,
						"checked": true
					}, {
						"title": "零售单价",
						"field": "salePric",
						"width": 41.57577958076415,
						"colspan": 1,
						"rowspan": 1,
						"checked": true
					}, {
						"title": "生产厂家",
						"field": "prodentpName",
						"width": 85.62288109906501,
						"colspan": 1,
						"rowspan": 1,
						"checked": true
					}, {
						"title": "生产批号",
						"field": "manuLotnum",
						"width": 56.11054160149894,
						"colspan": 1,
						"rowspan": 1,
						"checked": true
					}]
				]
			},
			"printElementType": {
				"title": "表格",
				"type": "tableCustom"
			}
		}, {
			"options": {
				"left": 30,
				"top": 151.5,
				"height": 20,
				"width": 100,
				"title": "操作人",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 207,
				"top": 151.5,
				"height": 20,
				"width": 100,
				"title": "过单人",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 171,
				"top": 6,
				"height": 30,
				"width": 120,
				"field": "flowDialogTitle",
				"fontFamily": "SimSun",
				"fontSize": 12,
				"textAlign": "right",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}, {
			"options": {
				"left": 405,
				"top": 151.5,
				"height": 19.5,
				"width": 158,
				"title": "打印时间",
				"field": "nowDateTime",
				"textContentVerticalAlign": "middle"
			},
			"printElementType": {
				"type": "text"
			}
		}],
		"paperNumberLeft": 565,
		"paperNumberTop": 397
	}]
}